/**
 * In most cases, the focus rings are applied as predefined box-shadow configurations, but if the element is already using the box-shadow CSS property, they can be applied as outline as well.
 * Much like color and borders, the focus styles applied should correspond to their implied semantic meaning.
 */

export const focusRings = {
  primary: {
    default: '0 0 0 3px rgb(181,109,198), 0 0 0 1.5px rgb(253,245,255)',
    simple: '0 0 0 2px rgb(181,109,198)',
  },
  destruction: {
    default: '0 0 0 3px rgb(191,49,68), 0 0 0 1.5px rgb(254,229,233)',
    simple: '0 0 0 2px rgb(191,49,68)',
  },
  neutral: {
    default: '0 0 0 3px rgb(153,144,148), 0 0 0 1.5px rgb(245,244,244)',
    simple: '0 0 0 2px rgb(153,144,148)',
  },
  success: {
    default: '0 0 0 3px rgb(14,153,118), 0 0 0 1.5px rgb(230,255,247)',
    simple: '0 0 0 2px rgb(14,153,118)',
  },
  info: {
    default: '0 0 0 3px rgb(36,137,169), 0 0 0 1.5px rgb(230,251,255)',
    simple: '0 0 0 2px rgb(36,137,169)',
  },
  warning: {
    default: '0 0 0 3px rgb(189,91,0), 0 0 0 1.5px rgb(255,245,245)',
    simple: '0 0 0 2px rgb(189,91,0)',
  },
};
